import { apiSlice } from "../store/api/baseApi";

interface EditableContentBlockRecord {
  contentId: string;
  content: string;
  title?: string;
}

const editableContentBlockSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getContent: builder.query<
      { content: string; title?: string } | undefined,
      string
    >({
      query: () => ({
        url: `/editable-content-blocks`,
        method: "get",
      }),
      transformResponse: (
        response: EditableContentBlockRecord[] | undefined,
        _,
        contentId,
      ) => {
        const record = (response ?? []).find(
          (candidate) => candidate.contentId === contentId,
        );

        return record
          ? { content: record.content, title: record.title }
          : undefined;
      },
    }),
    updateEditableContentBlock: builder.mutation<
      void,
      { contentId: string; content: string; title?: string }
    >({
      // Customer-app reads stay on `/editable-content-blocks`, but the
      // editor save path is admin-only and must flow through `/admin/*`
      // so backend admin middleware protects the mutation.
      query: (content) => ({
        url: `/admin/editable-content-blocks`,
        method: "put",
        data: content,
      }),
    }),
  }),
});

export const { useGetContentQuery, useUpdateEditableContentBlockMutation } =
  editableContentBlockSlice;
